import React from "react";

import BenefitCard from "./components/BenefitCard/BenefitCard";

import idEarlyWarningSystemIcon from '../../../utils/assets/home/icons/id-early-warning-system.png';
import identityTheftIcon from '../../../utils/assets/home/icons/identity-theft-insurance.png';
import identityProtectionTrainingIcon from '../../../utils/assets/home/icons/identity-protection-training-center.png';
import searchReputationIcon from '../../../utils/assets/home/icons/online-Reputation-search.png';
import blackMarketIcon from '../../../utils/assets/home/icons/black-market-monitoring.png' ;
import identifyRecoveryIcon from '../../../utils/assets/home/icons/identity-recovery-and-restoration.png';
import emailSecutiryIcon from '../../../utils/assets/home/icons/junk-mail-reduction.png';
import legalSupportIcon from '../../../utils/assets/home/icons/legal-support.png';
import criminalRecordIcon from '../../../utils/assets/home/icons/criminal-background-report.png';
import walletIcon from '../../../utils/assets/home/icons/lost-wallet-services.png';
import creditFreezesIcon from '../../../utils/assets/home/icons/credit-security-freezes.png';
import fraudAlertIcon from '../../../utils/assets/home/icons/fraud-alert-assistance-24-7.png';

import './Benefit.css';
const Benefit = ({props}) => {
    
    const benefitCardInformation = [
        {
            cardTitle : "ID Early Warning System",
            cardIcon : idEarlyWarningSystemIcon,
            cardAbout : "If your identity is being used by someone else on the web, you can quickly detect and be alerted.",
            cardDescription : "Our innovative identity theft system scans hundreds of pieces of data at various random intervals, looking for signs of identity theft."
        },
        {
            cardTitle : "identity theft insurance",
            cardIcon : identityTheftIcon,
            cardAbout : "Your coverage can help you recover between $25 K and $1 M for fraud-related expenses.",
            cardDescription : "AIG's Identity Theft Reimbursement Insurance covers notary fees, certified mail fees, lost wages, loan application fees, attorney fees and more."
        },
        {
            cardTitle : "Identity Theft Prevention Resources",
            cardIcon : identityProtectionTrainingIcon,
            cardAbout : "Educational guides to help you stay protected.",
            cardDescription : "Access tips and best practices to avoid phishing scams and secure your data (complementary to your Identity Theft Protection plan)."
        },
        {
            cardTitle : "Online Reputation Search",
            cardIcon : searchReputationIcon,
            cardAbout : "We scan for misuse of your personal data online.",
            cardDescription : "Detects if your name, email, or other sensitive information appears in data breaches or fraudulent sites (covered under your plan)."
        },
        {
            cardTitle : "Internet Black Market Monitoring",
            cardIcon : blackMarketIcon,
            cardAbout : "Your data could be compromised by opening malicious e-mails, accepting cookies from suspicious websites, or downloading infected files.",
            cardDescription : "We constantly monitor the Deep Web for signs or leaks of sensitive personal information that may have been exposed by a potential hack."  
        },
        {
            cardTitle : "Identity Recovery and Restoration",
            cardIcon : identifyRecoveryIcon,
            cardAbout : "We are here to help you recover your identity, saving you time, money and headaches.",
            cardDescription : "We guide you through every step of the process, providing advice and assistance from our many experts in the field, or we handle the entire process for you."
        },
        {
            cardTitle : "Junk Mail Reduction",
            cardIcon : emailSecutiryIcon,
            cardAbout : "Tired of having your mailbox filled with junk mail and unsolicited advertisements?",
            cardDescription : "By removing your name from spam lists and information databases, our Green Mailbox service prevents the widespread use of your personal information."
        },
        {
            cardTitle : "Identity Theft Legal Assistance",
            cardIcon : legalSupportIcon,
            cardAbout : "Coverage for attorney fees if your identity is stolen.",
            cardDescription : "Reimbursement for legal costs to resolve fraud-related issues (e.g., wrongful charges, civil judgments). Subject to AIG approval."
        },
        {
            cardTitle : "Criminal Identity Theft Monitoring",
            cardIcon :criminalRecordIcon ,
            cardAbout : "Alerts if your identity is linked to criminal activity.",
            cardDescription : "Monitors arrests, warrants, or legal violations tied to your personal data (covered under your plan)."
        },
        {
            cardTitle : "Lost Wallet Service",
            cardIcon : walletIcon,
            cardAbout : "Eliminate the stress of reporting your cards if your wallet or purse is stolen.",
            cardDescription : "Our service makes it harder for criminals to steal your money by keeping your critical financial information safe in one place, giving you time to contact financial institutions quickly."
        },
        {
            cardTitle : "Credit Security Freezes",
            cardIcon : creditFreezesIcon,
            cardAbout : "Block creditors from accessing your credit information without your permission by locking your accounts.",
            cardDescription : "If you have reason to believe that your personal information or identity has been stolen, a credit freeze can help protect you from fraud by placing a freeze on each of your credit profiles. "
        },
        {
            cardTitle : "Fraud Alert Assistance 24-7",
            cardIcon : fraudAlertIcon,
            cardAbout : "Anyone concerned about identity theft needs to focus on protecting their credit profile.",
            cardDescription : "Learn how to set credit fraud alerts on your accounts with step-by-step instructions from our experts. Fraud alerts can be one of your best identity protection tools."
        },

    ]


    return (
     <section className="Benefit__main-contiainer">
        <div className="Benefit__inner-contianer">
            {
                benefitCardInformation.map((cardInfo, index)=>(
                    <BenefitCard key={index} props={cardInfo}/>
                ))
            }
        </div>
     </section>
    );
};

export default Benefit; 